import React from "react";
import HttpModule, { HTTP_PROGRESS } from '../../../services/http.module';
import { Button, Select, MenuItem, Typography } from '@material-ui/core'


export class SetDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 0,
      validTurns: [],
      isMount: false,
      httpProgress: "",
      reservedDateId: ""
    };
  }

  LoadValidDates = () => {
    this.setState({
      httpProgress: HTTP_PROGRESS.PENDING
    })
    const { mode } = this.state;
    HttpModule.GetDates(mode)
      .then((result) => {
        this.setState({
          validTurns: result,
          reservedDateId: result.length > 0 ? result[0]._id : null
        })
        if( result.length > 0) {
          this.props.SubmitData({
            reservedDateId: result[0]._id
          }, 'step2');
        }
        this.setState({
          httpProgress: HTTP_PROGRESS.DONE,
        })
        setTimeout(() => {
          this.setState({
            isMount: true
          })
        }, 500)

        if (result.length > 0) {
          this.props.ActivateNext(true);
        }
      })
      .catch((_err) => {
        this.setState({
          httpProgress: HTTP_PROGRESS.FAILED
        })
      });
  }

  SetMode = () => {
    return new Promise((resolve, reject) => {
      const mode = this.props.mode() + 1;
      this.setState({
        mode
      }, () => {
        resolve(mode)
      })
    })
  }

  componentDidMount() {
    this.SetMode()
      .then(() => {
        this.LoadValidDates();
      });

    this.props.ActivateNext(false);
    /*
    *
    * endHour: 16
      endMinute: 30
      membersCount: 0
      membersLimit: false
      startDate: "4/7/1400"
      startDay: "چهارشنبه"
      startHour: 15
      startMinute: 0
      turnType: 3
      _id: "61139488ab450e39d0afed2a"

    *
    * */
  }

  onReservationChange = (e) => {
    this.setState({
      reservedDateId: e.target.value
    }, () => {
      this.props.SubmitData({
        reservedDateId: e.target.value
      }, 'step2');
    })
  }

  render() {
    return <div className="text-center">
      {this.state.httpProgress === ""
        ? <></>
        : this.state.httpProgress === HTTP_PROGRESS.DONE ? <>
          {this.state.validTurns.length === 0 ? <div>
            <Typography variant={'h6'}
              className={'font-weight-bold text-center p-2'} align={'center'}>
              متاسفانه کارگاه انتخابی شما ظرفیت کامل را دارد و جای خالی ندارد
            </Typography>
            <div className="row">
              <div className="col-12 text-center p-2">
                <Button
                  onClick={this.props.GoBack}
                  variant={'contained'}
                  className={'shadow'}
                  color={'primary'} >
                  بازگشت به انتخاب کارگاه
                </Button>
              </div>
            </div>
          </div> : <div>
            <Typography
              variant={'h6'}
              className={'font-weight-bold text-center p-2'}
              align={'center'}>
              یک زمان را انتخاب کنید
            </Typography>
            <Typography
              variant={'body2'}
              className={`font-weight-bold wow fadeIn shadow-sm border-dark border-right bg-warning text-dark rounded text-center p-2`}
              style={{
                transition: "0.25s ease",
                opacity: `${this.state.isMount ? 1 : 0}`,
                transform: `${this.state.isMount ? "scale(1)" : "scale(0.5)"}`
              }}
              align={'center'}
            >
              توجه: بعد از انتخاب زمان ، امکان بازگشت وجود ندارد
            </Typography>
            <div className="row">
              <div className="col-12 text-center">
                <Select
                  value={this.state.reservedDateId}
                  className={'m-5 w-75'}
                  variant={'outlined'}
                  onChange={this.onReservationChange}
                >
                  {this.state.validTurns.map(item => {
                    return (
                      <MenuItem value={item._id} key={item._id}>
                        {item.startHour}:{item.startMinute}  تا {item.endHour}:{item.endMinute} - {item.startDay} مورخ {item.startDate}
                      </MenuItem>
                    )
                  })}
                </Select>
                <Button onClick={this.props.GoBack} variant={'contained'} color={'primary'}>
                  بازگشت به انتخاب تعرفه
                </Button>
              </div>
            </div>
          </div>}
        </>
          : this.state.httpProgress === HTTP_PROGRESS.PENDING ? <> <Typography
            variant={'h6'}
            className={'font-weight-bold text-center p-2'}
            align={'center'}>
            درحال دریافت اطلاعات
          </Typography> </> :
            <>
              <Typography
                variant={'h6'}
                className={'font-weight-bold text-danger text-center p-2'}
                align={'center'}>
                خطا در دریافت اطلاعات
              </Typography>
            </>
      }
    </div>;
  }
}

export default SetDate;